import React, { useEffect, useRef, useState } from "react";
import { COUNTERS } from "../mock";

const format = (n) => {
  if (n >= 100000) return n.toLocaleString("en-IN");
  return n.toLocaleString();
};

const Counter = ({ target, suffix }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const dur = 1800;
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - start) / dur);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(Math.floor(target * eased));
            if (p < 1) requestAnimationFrame(tick);
            else setVal(target);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.4 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [target]);

  return (
    <div className="counter-num" ref={ref}>{format(val)}{suffix}</div>
  );
};

const Counters = () => {
  return (
    <section className="counters grain">
      <div className="container">
        <div className="counters-grid">
          {COUNTERS.map((c, i) => (
            <div key={i}>
              <Counter target={c.target} suffix={c.suffix} />
              <div className="counter-label">{c.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Counters;
